/*
 * @Author: gaobin
 * @Date: 2025-07-05 15:30:29
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-07 11:02:20
 * @Description: 订单
 */
const groupOrderMap = {
  // 助力订单列表
  getHelpChopListExt: '/usb/uwb-app/api/v1/helpChop/myHelpChopList',
  // 创建普通订单
  createOrder: '/usb/uwb-app/api/v1/order/createOrder',
};

export default groupOrderMap;
